export const DEFAULT_AMOUNT_DECIMALS = 2;
export const ORDER_CREATION_AMOUNT_DECIMALS = DEFAULT_AMOUNT_DECIMALS;

export const getAmountEpsilon = (decimals = DEFAULT_AMOUNT_DECIMALS) =>
  1 / 10 ** decimals;

export const ORDER_CREATION_AMOUNT_EPSILON = getAmountEpsilon(
  ORDER_CREATION_AMOUNT_DECIMALS,
);

export const getConfiguredAmountDecimals = (getValue) => {
  const configured = Number(
    typeof getValue === 'function'
      ? getValue('productPricing.orderAmountDecimals', DEFAULT_AMOUNT_DECIMALS)
      : DEFAULT_AMOUNT_DECIMALS,
  );

  return Number.isFinite(configured) && configured >= 0
    ? configured
    : DEFAULT_AMOUNT_DECIMALS;
};

export const formatDecimalAmount = (
  value,
  decimals = DEFAULT_AMOUNT_DECIMALS,
) => Number(value || 0).toFixed(decimals);

export const formatOptionalDecimalAmount = (
  value,
  decimals = DEFAULT_AMOUNT_DECIMALS,
) => {
  if (value === null || value === undefined || value === '') return null;

  const amount = Number(value);
  return Number.isFinite(amount)
    ? formatDecimalAmount(amount, decimals)
    : null;
};

export const applyDiscounts = (price, ...discounts) =>
  discounts.reduce(
    (value, discount) => value - (value / 100) * Number(discount || 0),
    Number(price || 0),
  );
